<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig dx">
        <!--
        <bar-card class="lefts lefts1" :bg="'border-new'">
          <g-title>产业概况</g-title>
          <div class="panelContent">
            <left-top />
          </div>
        </bar-card> -->
        <bar-card class="lefts lefts1" :bg="'border-new'">
          <!-- <g-title :bg="'pp'">品牌创建</g-title> -->
          <g-title :bg="'pp'">农林牧渔业产值变化情况</g-title>
          <div class="panelContent">
            <right-qx />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border-new'">
          <g-title :bg="'green'">各区(县级市)/各行业农业产值占比</g-title>
          <div class="panelContent">
            <right-cp />
          </div>
        </bar-card>
        <bar-card class="lefts" :bg="'border-new'">
          <g-title :bg="'green'">城乡居民人均可支配收入</g-title>
          <div class="panelContent">
            <right-sr />
          </div>
        </bar-card>
        <!--
        <bar-card class="lefts" :bg="'border-new'">
          <g-title :bg="'green'">绿色生态农业</g-title>
          <div class="panelContent">
            <left-bot />
          </div>
        </bar-card> -->
      </div>
    </v-drawer>
  </div>
</template>

<script>
import gTitle from "../components/gTitle";
import rightCp from "./rightBar/rightCp";
// import rightXm from "./rightBar/rightXm";
import rightQx from "./rightBar/rightQx";
// import rightYz from "./rightBar/rightYz";
import rightSr from "./rightBar/rightSr";
// import RightSr from './rightBar/rightSr.vue';
export default {
  components: {
    rightCp,
    // rightXm,
    rightQx,
    // rightYz
    rightSr,
    gTitle
  },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.dx
  height 100%
.panelContent
  height calc(100% - 39px)
  color #fff
.lefts
  margin-bottom 10px
  height calc(34.33% - 10px)
.lefts1
  height calc(34.33% - 10px)
.lefts2
  height calc(31.33% - 10px)
.leftBar
  >>>.side
    bottom 8px
@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important
</style>
